import {AfterContentInit, AfterViewInit, Component, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {Right, Client, Sender, Recipient, VehicleState} from '../../models/models';
import {Translation} from '../../models/translation';
import {LoginService} from '../../services/login.service';
import {AddressService} from '../../services/address.service';
import {VehicleStateService} from '../../services/vehiclestates.service';
import {CheckService} from '../../services/check.service';
import {MatLegacySelectChange as MatSelectChange} from '@angular/material/legacy-select';
import {UntypedFormControl} from '@angular/forms';
import {GridComponent, ColumnModel, ExcelExportService, ResizeService, ColumnMenuService, SortService, EditService} from '@syncfusion/ej2-angular-grids';
import Swal from 'sweetalert2';

interface Type {
  id: number;
  text: string;
}
class Trader {
  id: string;
  text: string;
}

@Component({
  selector: 'app-state',
  styleUrls: ['./state.component.css'],
  templateUrl: './state.component.html',
  providers: [ResizeService, ColumnMenuService, SortService, EditService, ExcelExportService]
})
export class StateComponent implements OnInit, AfterViewInit, OnChanges, AfterContentInit {

  @ViewChild('stateGrid', {static: true}) private stateGrid: GridComponent;

  public options: ColumnModel[];
  public locale: string;
  public translation: Translation;
  public rights: Right[];
  public dataSource: VehicleState[] = [];
  public hasAllRights = 0;
  public traderTypes: Type[] = [];
  public selectedTraderType: number;
  public daysBackInput: number;
  public traders = new UntypedFormControl();
  public tempTrader: Trader;
  public traderList: Trader[] = [];
  public splittedAddresses: string[] = [];
  public selectedTraders: string;
  public selectedOption: string[] = [];
  public showVertical = false;
  public IsCheckedCompleted = false;
  public AcceptedCompleted = false;
  public DeclinedCompleted = false;
  public ScheduledForCollectionCompleted = false;
  public PickedUpCompleted = false;
  public ScheduledForDeliveryCompleted = false;
  public InTransitCompleted = false;
  public DeliveredCompleted = false;
  public client: Client;
  public sender: Sender;
  public recipient: Recipient;
  public clientEmailSplit = [];
  public senderEmailSplit = [];
  public recipientEmailSplit = [];
  public addressContentIsActive = false;
  public multiPartnerUser = false;
  public chassisNumber = '';
  public referenceNumber = '';

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private addressService: AddressService,
    private vehicleStateService: VehicleStateService
  ) {
    switch (localStorage.getItem('Language')) {
      case 'DE': this.locale = 'de-CH'; break;
      case 'IT': this.locale = 'it-CH'; break;
      case 'FR': this.locale = 'fr-CH'; break;
      case 'EN': this.locale = 'en-GB'; break;
      default: this.locale = 'en-GB'; break;
    }
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkModule(80);
    this.translation = JSON.parse(localStorage.getItem('Translation'));

    // Set MultiPartnerUser
    this.multiPartnerUser = sessionStorage.getItem('MultiPartnerUser') === 'true';

    // For Responsive Stepper
    this.showVertical = window.innerWidth <= 1200;
    window.onresize = () => this.showVertical = window.innerWidth <= 1200;

    // Get user rights from session
    this.rights = JSON.parse(sessionStorage.getItem('Rights'));

    // Loop user rights and add it to array
    this.rights.forEach(right => {
      switch (right.RightId) {
        case 1:
          this.hasAllRights += 1;
          this.traderTypes.push({id: 1, text: this.translation.Client});
          break;
        case 2:
          this.hasAllRights += 1;
          this.traderTypes.push({id: 2, text: this.translation.Sender});
          break;
        case 3:
          this.hasAllRights += 1;
          this.traderTypes.push({id: 3, text: this.translation.Recipient});
          break;
        default: break;
      }
    });
    // Add "All" on first position, if user has all rights
    if (this.hasAllRights === 3) { this.traderTypes.unshift({id: 0, text: this.translation.All}); }

    // Get assigned addresses, fill dropdown and select primary or all
    this.splittedAddresses = sessionStorage.getItem('Addresses').split(',');
    if (!this.splittedAddresses.includes(JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerAid)) {
      this.splittedAddresses.push(JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerAid);
    }
    this.addressService.getAddresses().subscribe(response => {
      if (response.Ok) {
        response.Obj.forEach(address => {
          if (this.splittedAddresses.includes(address.PartnerAid)) {
            this.tempTrader = new Trader();
            this.tempTrader.id = address.PartnerAid;
            this.tempTrader.text = '[' + address.Description + ', ' + (address.DeliveryAddition === '' ? '' : address.DeliveryAddition + ', ') + address.DeliveryCity + ']';
            this.traderList.push(this.tempTrader);
            this.selectedOption.push(address.PartnerAid);
          }
        });
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }

      // Default values
      this.daysBackInput = 0;
      this.selectedTraderType = this.hasAllRights === 3 ? 0 : this.rights[0].RightId;
      this.initGrid();
      if (JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerAid !== '') {
        this.selectedTraders = sessionStorage.getItem('Addresses');
        if (sessionStorage.getItem('MultiPartnerUser').toString() !== 'true') {
          this.loadDataForGrid(false);
        }
      }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  loadDataForGrid(specialMultiUser: boolean) {
    if (!specialMultiUser) {
      if (this.daysBackInput == null) { this.daysBackInput = 0; }
      if (this.selectedTraders === undefined) { this.selectedTraders = ''; }
      this.selectedTraders.trim();
      this.vehicleStateService.getVehicleStatesForStatusGridByTraders(this.selectedTraderType, this.selectedTraders, this.daysBackInput, +sessionStorage.getItem('UserId')).subscribe(response => {
        if (response.Ok) {
          this.dataSource = response.Obj;
        } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire(this.translation.InternalServerError); });
    } else {
      if (this.chassisNumber === null) { this.chassisNumber = ''; }
      if (this.referenceNumber === null) { this.referenceNumber = ''; }
      if (this.chassisNumber === '' && this.referenceNumber === '') {
        Swal.fire(this.translation.Error, this.translation.YouMustFillChassisOrReference, 'error');
      } else {
        this.vehicleStateService.getVehicleStatesForStatusGridByReferences(this.chassisNumber, this.referenceNumber, +sessionStorage.getItem('UserId')).subscribe(response => {
          if (response.Ok) {
            this.dataSource = response.Obj;
          } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
          if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
      }
    }
  }

  initGrid() {
    this.stateGrid.allowExcelExport = true;
    this.stateGrid.allowPaging = true;
    this.stateGrid.allowResizing = true;
    this.stateGrid.pageSettings = {pageCount: 5};
    this.stateGrid.toolbar = ['Search', 'ExcelExport'];
    this.stateGrid.editSettings = {allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal'};
    this.options = [
      {
        field: 'OrderId',
        headerText: this.translation.OrderNumber,
        textAlign: 'Left',
        isPrimaryKey: true,
        width: 88
      },
      {
        field: 'ClientId',
        headerText: 'ClientId',
        textAlign: 'Left',
        visible: false
      },
      {
        field: 'SenderId',
        headerText: 'SenderId',
        textAlign: 'Left',
        visible: false
      },
      {
        field: 'SenderName',
        headerText: this.translation.Sender,
        textAlign: 'Left',
      },
      {
        field: 'SenderCity',
        headerText: this.translation.SenderCity,
        textAlign: 'Left',
        width: 129
      },
      {
        field: 'RecipientId',
        headerText: 'RecipientId',
        textAlign: 'Left',
        visible: false
      },
      {
        field: 'RecipientName',
        headerText: this.translation.Recipient,
        textAlign: 'Left',
      },
      {
        field: 'RecipientCity',
        headerText: this.translation.RecipientCity,
        textAlign: 'Left',
        width: 136
      },
      {
        field: 'ModelName',
        headerText: this.translation.Model,
        textAlign: 'Left',
        width: 140
      },
      {
        field: 'ClientReference1',
        headerText: this.translation.ChassisNumber,
        textAlign: 'Left',
        width: 185
      },
      {
        field: 'ClientReference2',
        headerText: this.translation.Reference,
        textAlign: 'Left',
        width: 105
      },
      {
        field: 'DeliveryStatus',
        headerText: this.translation.Status,
        textAlign: 'Left',
        width: 140
      },
      {
        field: 'StatusId',
        headerText: 'Status ID',
        textAlign: 'Left',
        visible: false
      },
      {
        field: 'DeliveryAppointment',
        headerText: this.translation.Date,
        textAlign: 'Left',
      }
    ];
  }

  ngAfterViewInit(): void {
    this.stateGrid.dataSource = this.dataSource;
    this.stateGrid.columns = this.options;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.stateGrid.dataSource = this.dataSource;
    this.stateGrid.columns = this.options;
  }

  ngAfterContentInit(): void {
    this.stateGrid.dataSource = this.dataSource;
    this.stateGrid.columns = this.options;
    this.stateGrid.columnMenuItems = ['AutoFitAll', 'AutoFit', 'SortDescending'];
    this.stateGrid.allowResizing = true;
    this.stateGrid.enableAutoFill = true;
    this.stateGrid.allowSorting = true;
  }

  onTypeSelectChange(event: MatSelectChange) {
    this.selectedTraderType = event.value;
  }

  onTraderSelectChange(event: MatSelectChange) {
    this.selectedTraders = '';
    // tslint:disable-next-line:prefer-for-of
    for (let x = 0; x < event.value.length; x++) { this.selectedTraders += event.value[x] + ','; }
    this.selectedTraders = this.selectedTraders.substring(0, this.selectedTraders.length - 1);
  }

  rowSelect(args: any) {
    // Reset stepper
    this.IsCheckedCompleted = false;
    this.AcceptedCompleted = false;
    this.AcceptedCompleted = false;
    this.DeclinedCompleted = false;
    this.ScheduledForCollectionCompleted = false;
    this.PickedUpCompleted = false;
    this.ScheduledForDeliveryCompleted = false;
    this.InTransitCompleted = false;
    this.DeliveredCompleted = false;
    // Update stepper
    switch (args.data.StatusId) {
      case 0:
        this.IsCheckedCompleted = true; break;
      case 1:
      case 7:
        this.IsCheckedCompleted = true;
        this.AcceptedCompleted = true;
        break;
      case 2:
        this.IsCheckedCompleted = true;
        this.DeclinedCompleted = true;
        break;
      case 3:
        this.IsCheckedCompleted = true;
        this.AcceptedCompleted = true;
        this.DeclinedCompleted = true;
        this.ScheduledForCollectionCompleted = true;
        break;
      case 4:
        this.IsCheckedCompleted = true;
        this.AcceptedCompleted = true;
        this.DeclinedCompleted = true;
        this.ScheduledForCollectionCompleted = true;
        this.PickedUpCompleted = true;
        break;
      case 5:
        this.IsCheckedCompleted = true;
        this.AcceptedCompleted = true;
        this.DeclinedCompleted = true;
        this.ScheduledForCollectionCompleted = true;
        this.PickedUpCompleted = true;
        this.InTransitCompleted = true;
        this.ScheduledForDeliveryCompleted = true;
        break;
      case -1:
        this.IsCheckedCompleted = true;
        this.AcceptedCompleted = true;
        this.DeclinedCompleted = true;
        this.ScheduledForCollectionCompleted = true;
        this.PickedUpCompleted = true;
        this.InTransitCompleted = true;
        break;
      case 6:
        this.IsCheckedCompleted = true;
        this.AcceptedCompleted = true;
        this.DeclinedCompleted = true;
        this.ScheduledForCollectionCompleted = true;
        this.PickedUpCompleted = true;
        this.ScheduledForDeliveryCompleted = true;
        this.InTransitCompleted = true;
        this.DeliveredCompleted = true;
        break;
      default: break;
    }
    this.addressService.getAddressByPartnerAid(args.data.SenderId).subscribe(responseSender => {
      if (responseSender.Ok) {
        this.sender = new Sender();
        this.sender.Name = responseSender.Obj.Description;
        this.sender.Contact = responseSender.Obj.RevUser;
        this.senderEmailSplit = responseSender.Obj.Email.split(';');
        this.sender.Phone = responseSender.Obj.Phone;
        this.sender.AddressLine1 = responseSender.Obj.DeliveryStreet;
        this.sender.AddressLine2 = responseSender.Obj.DeliveryAddition;
        this.sender.Zip = +responseSender.Obj.DeliveryZip;
        this.sender.City = responseSender.Obj.DeliveryCity;
        this.addressService.getAddressByPartnerAid(args.data.RecipientId).subscribe(responseRecipient => {
          if (responseRecipient.Ok) {
            this.recipient = new Recipient();
            this.recipient.Name = responseRecipient.Obj.Description;
            this.recipient.Contact = responseRecipient.Obj.RevUser;
            this.recipientEmailSplit = responseRecipient.Obj.Email.split(';');
            this.recipient.Phone = responseRecipient.Obj.Phone;
            this.recipient.AddressLine1 = responseRecipient.Obj.DeliveryStreet;
            this.recipient.AddressLine2 = responseRecipient.Obj.DeliveryAddition;
            this.recipient.Zip = +responseRecipient.Obj.DeliveryZip;
            this.recipient.City = responseRecipient.Obj.DeliveryCity;
            this.addressService.getAddressByPartnerAid(args.data.ClientId).subscribe(responseClient => {
              if (responseClient.Ok) {
                this.client = new Client();
                this.client.Name = responseClient.Obj.Description;
                this.client.Contact = responseClient.Obj.RevUser;
                this.clientEmailSplit = responseClient.Obj.Email.split(';');
                this.client.Phone = responseClient.Obj.Phone;
                this.client.AddressLine1 = responseClient.Obj.DeliveryStreet;
                this.client.AddressLine2 = responseClient.Obj.DeliveryAddition;
                this.client.Zip = +responseClient.Obj.DeliveryZip;
                this.client.City = responseClient.Obj.DeliveryCity;

                this.addressContentIsActive = true;
              } else if (responseClient.Msg === 'Internal Server Error') { console.log(responseClient.Ex); }
              if (responseClient.Msg) { this.toast.fire({title: responseClient.Msg, icon: responseClient.Ok ? 'success' : 'error'}); }
            }, error => { this.toast.fire(this.translation.InternalServerError); });
          } else if (responseRecipient.Msg === 'Internal Server Error') { console.log(responseRecipient.Ex); }
          if (responseRecipient.Msg) { this.toast.fire({title: responseRecipient.Msg, icon: responseRecipient.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
      } else if (responseSender.Msg === 'Internal Server Error') { console.log(responseSender.Ex); }
      if (responseSender.Msg) { this.toast.fire({title: responseSender.Msg, icon: responseSender.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  toolbarClick(args: any) {
    if (args.item.id.includes('excelexport')) { this.stateGrid.excelExport(); }
  }
}
